import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { NgxFormlyDemoComponent } from './ngx-formly/ngx-formly-demo.component';
import { SharedModule } from '@app/shared/shared.module';
import { SimpleTestCustomComponent } from './ngx-formly/simple-test-custom.component';
import { CommonModule } from '@angular/common';
import { ContactInfoDemoComponent } from './contact/contact-info-demo.component';
import { DialogDemoComponent } from './dialog/dialog-demo.component';
import { CacheDemoComponent } from './cache/cache-demo.component';
import { UserProfileDemoComponent } from './userprofile/user-profile-demo.component';
import { NgSelectDemoComponent } from './ngx-formly/ng-select-demo.component';
import { WizardDemoComponent } from './wizard/wizard-demo.component';
import { WizardDemoAppComponent } from './wizard/wizard-demo-app.component';
import { WizardDemoTestAppComponent } from './wizard/wizard-test-app.component';
import { FixedDemoComponent } from './fixed/fixed-demo.component';
import { InvoiceInfoDemoComponent } from './invoice-info/invoice-info-demo.component';
import { EmbeddedReportDemoComponent } from './embedded-report/embedded-report-demo.component';
import { PunchoutCatalogDemoComponent } from './punchout/punchout-catalog-demo.component';
import { OrderModule } from '../order/order.module';
import { TrackByDemoComponent } from './track-by/track-by-demo.component';
import { CombinedDateDemoComponent } from './combined-date/combined-date-demo.component';
import { DualMultiSelectDemoComponent } from './dual-multi-select/dual-multi-select-demo.component';
import { MultiFileUploadDemoComponent } from './multi-file-upload/multi-file-upload-demo.component';
import { CompanyDemoComponent } from './company/company-demo.component';
import { StatusMessageDemoComponent } from './status-message/status-message-demo.component';
import { BusyButtonDemoComponent } from './busy-button/busy-button-demo.component';
import { DemoComponent } from './demo.component';
import { TranslationCategory } from '@app/shared/services/ga-state.service';
import { GaStateDeclaration } from '@type_definitions/datatypes';
import { TRANSLATION_READY_RESOLVER } from '@app/app-routes.config';

export const states:GaStateDeclaration[] = [
  {
    name: 'main.demo',
    url: '/demo',
    abstract: true,
    component: DemoComponent,
    data: {
      translate: true,
      modules: [TranslationCategory.WEBSHOP]
    },
    resolve: [TRANSLATION_READY_RESOLVER]
  },
  {
    name: 'main.demo.formly2',
    url: '/formly2',
    component: NgxFormlyDemoComponent
  },
  {
    name: 'main.demo.ngselect',
    url: '/ng-select',
    component: NgSelectDemoComponent
  },
  {
    name: 'main.demo.contactinfo',
    url: '/contact-info',
    component: ContactInfoDemoComponent
  },
  {
    name: 'main.demo.dialog',
    url: '/dialog',
    component: DialogDemoComponent
  },
  {
    name: 'main.demo.cache',
    url: '/cache',
    component: CacheDemoComponent
  },
  {
    name: 'main.demo.invoiceinfo',
    url: '/invoiceinfo',
    component: InvoiceInfoDemoComponent
  },
  {
    name: 'main.demo.userprofile',
    url: '/userprofile',
    component: UserProfileDemoComponent
  },
  {
    name: 'main.demo.wizard',
    url: '/wizard',
    abstract: true,
    component: WizardDemoComponent
  },
  {
    name: 'main.demo.wizard.demoapp',
    url: '/app',
    component: WizardDemoAppComponent
  },
  {
    name: 'main.demo.wizard.testapp',
    url: '/test',
    component: WizardDemoTestAppComponent
  },
  {
    name: 'main.demo.fixed',
    url: '/fixed',
    component: FixedDemoComponent
  },
  {
    name: 'main.demo.embeddedreport',
    url: '/embedded-report',
    component: EmbeddedReportDemoComponent
  },
  {
    name: 'main.demo.punchoutcatalog',
    url: '/punchout-catalog',
    component: PunchoutCatalogDemoComponent,
    data: {
      noScrollTop: true
    }
  },
  {
    name: 'main.demo.trackby',
    url: '/track-by',
    component: TrackByDemoComponent
  },
  {
    name: 'main.demo.combineddate',
    url: '/combineddate',
    component: CombinedDateDemoComponent
  },
  {
    name: 'main.demo.dualmultiselect',
    url: '/dualmultiselect',
    data: {
      noScrollTop: true
    },
    component: DualMultiSelectDemoComponent
  },
  {
    name: 'main.demo.multifileupload',
    url: '/multifileupload',
    data: {
      noScrollTop: true
    },
    component: MultiFileUploadDemoComponent
  },
  {
    name: 'main.demo.company',
    url: '/company',
    component: CompanyDemoComponent
  },
  {
    name: 'main.demo.statusmessage',
    url: '/statusmessage',
    component: StatusMessageDemoComponent
  },
  {
    name: 'main.demo.busybutton',
    url: '/busybutton',
    component: BusyButtonDemoComponent
  }
];


@NgModule({
  imports: [
    UIRouterModule.forChild({ states }),
    CommonModule,
    SharedModule,
    OrderModule
  ],
  declarations: [
    DemoComponent,
    NgxFormlyDemoComponent,
    NgSelectDemoComponent,
    SimpleTestCustomComponent,
    ContactInfoDemoComponent,
    DialogDemoComponent,
    CacheDemoComponent,
    UserProfileDemoComponent,
    WizardDemoComponent,
    WizardDemoAppComponent,
    WizardDemoTestAppComponent,
    FixedDemoComponent,
    InvoiceInfoDemoComponent,
    EmbeddedReportDemoComponent,
    PunchoutCatalogDemoComponent,
    TrackByDemoComponent,
    CombinedDateDemoComponent,
    DualMultiSelectDemoComponent,
    MultiFileUploadDemoComponent,
    CompanyDemoComponent,
    StatusMessageDemoComponent,
    BusyButtonDemoComponent
  ]
})
export class DemoModule {
}